import React, { useState, useEffect, useContext, Fragment } from "react";
import "./Home.scss";
import { AppContext } from "../../Context/AppContext";
// Custom Components
import Spinner from "../../Components/Spinner/Spinner";
import Screen1 from "../../Components/Screens/Screen1";
import Screen2 from "../../Components/Screens/Screen2";
import Screen3 from "../../Components/Screens/Screen3";
import Screen4 from "../../Components/Screens/Screen4";
import Screen5 from "../../Components/Screens/Screen5";
import Screen6 from "../../Components/Screens/Screen6";
import Screen7 from "../../Components/Screens/Screen7";
import Screen8 from "../../Components/Screens/Screen8";
import Screen9 from "../../Components/Screens/Screen9";
import Screen10 from "../../Components/Screens/Screen10";
import Screen11 from "../../Components/Screens/Screen11";
import Screen12 from "../../Components/Screens/Screen12";
import Screen13 from "../../Components/Screens/Screen13";


// Material UI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Header from "../../Components/common/header";
import Screen1_1 from "../../Components/Screens/Screen1_1";
import Screen1_2 from "../../Components/Screens/Screen1_2";

const Home = () => {
  const {
    screensData,
    setScreensData,
    activeScreen,
    setActiveScreen,
    showSnackbar,
    setShowSnackbar,
    snackbarMessage,
    showSpinner,
    activeFocus,
    setActiveFocus,
  } = useContext(AppContext);
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);

  const steps = [
    "Get Your Offer",
    "Trim",
    "Title/ Ownership",
    "Vin",
    "Wheels/Tires",
    "Key",
    "Engine/Transmission",
    "Catalytic Converter",
    "User Information",
    "Your Offer - Includes Free Pickup",
    "Contact Details",
    "Pickup Address",
    "Date & Time",
    "Thanks",
  ];
  const stepsInfoData = {
    year: {
      name: "Year",
      image: "year.png",
      text: "If you're not sure what year your car is, you can share your VIN with us and we'll figure it out. Have a look at your title, vehicle, or insurance card to find your VIN.",
    },
    make: {
      name: "Make",
      image: "make.jpg",
      text: "The make of your car is its brand name, such as Ford, Honda, Mercedes, etc. If you're not sure of your make, just look up your VIN and we'll figure it out.",
    },
    model: {
      name: "Model",
      image: "model.jpg",
      text: "The model tells us what kind of car you have, for example: Focus, Accord, Sonata, etc. If you're not sure of your model, just look up your VIN and we'll figure it out.",
    },
    vin: {
      name: "Vin",
      image: "vin.png",
      text: "Entering your vehicle identification number will let us quickly decode your vehicle's exact year, make, model. The VIN can be found on your car's windshield and door-jamb, the title, or your proof of insurance. Please note that there are never any letter I's, O's, or Q's.",
    },
    trim: {
      name: "Trim",
      image: "trim.png",
      text: "Trim is a fancy name for the style/sub-model of your car; for instance, Honda Fits come in a Base model or Sports style. Depending on the make of your car, it may be a series of letters, such as LX. Still unsure? Give us your VIN, we'll sort it out.",
    },
    title: {
      name: "Title",
      image: "title.png",
      text: "The title is the legal document indicating ownership of a vehicle. If you don't have the title, the vehicle's owner must be present at the time of pickup.",
    },
    owner: {
      name: "Owner",
      image: "title.png",
      text: "Are you the owner of this vehicle? Let us know if you are the owner of car or someone else.",
    },
    wheels: {
      name: "Wheels",
      image: "tires.png",
      text: "Are all the wheels mounted and tires in good condition? Let us know if there's a flat or if your car is missing wheels or tires.",
    },
    key: {
      name: "Key",
      image: "key.png",
      text: "Please let us know if you have the key or fob to start the car. Don't worry - we can still tow your car even if you don't have the key.",
    },
    engineTransmission: {
      name: "Engine Transmission",
      image: "startsdrives.png",
      text: "Please let us know if the vehicle has a complete engine and transmission. Don't worry, it's okay if the vehicle doesn't start or run. We just want to know if any major parts have been removed from the engine or transmission.",
    },
    catalyticConverter: {
      name: "Catalytic Converter",
      image: "catalyticConverter.jpg",
      text: "All vehicles come with a catalytic converter. Your vehicle most likely has its original catalytic converter unless it has been deliberately replaced or removed.",
    },
  };

  const handleReset = () => {
    setScreensData({
      screen1: {
        year: "",
        make: "",
        model: "",
        vin: "",
        vinDecodedDetails: {},
        yearError: false,
        makeError: false,
        modelError: false,
        vinError: false,
        makes: [],
        models: [],
      },
      screen1_1:{
        make: "",
      },
      screen1_2:{
        model: "",
      },
      screen2: {
        trim: "",
        trimError: false,
        trims: [],
      },
      screen3: {
        title: "",
        owner: "",
        titleError: false,
        ownerError: false,
      },
      screen4: {
        vin: "",
        vinError: false,
      },
      screen5: {
        wheels: "",
        wheelsError: false,
      },
      screen6: {
        key: "",
        keyError: false,
      },
      screen7: {
        engineTransmission: "",
        engineTransmissionError: false,
      },
      screen8: {
        catalyticConverter: "",
        catalyticConverterError: false,
      },
      screen9: {
        firstName: "",
        phone: "",
        email: "",
        firstNameError: false,
        phoneError: false,
        emailError: false,
      },
      screen10: {
        offeredPrice: 0,
      },
      screen11: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        firstNameError: false,
        lastNameError: false,
        phoneError: false,
        emailError: false,
      },
      screen12: {
        address: "",
        city: "",
        state: "",
        zipCode: "",
        addressError: false,
        cityError: false,
        stateError: false,
        zipCodeError: false,
      },
      screen13: {
        date: "",
        time: "",
        dateError: false,
        timeError: false,
      },
    });
    setActiveScreen(0);
  };

  const renderScreen = () => {
    return (
      <Fragment>
        {/* Screen 1 */}
        <Fragment>{activeScreen === 0 && <Screen1 />}</Fragment>

        {/* Screen 1_1 
        <Fragment>{activeScreen === 1 && <Screen1_1 />}</Fragment>
        */}
        {/* Screen 1_2 
        <Fragment>{activeScreen === 2 && <Screen1_2 />}</Fragment>
        */}

        {/* Screen 2 - This Screen will never be shown. */}
        <Fragment>{activeScreen === 1 && <Screen2 />}</Fragment>

        {/* Screen 3 */}
        <Fragment>{activeScreen === 2 && <Screen3 />}</Fragment>

        {/* Screen 4 */}
        <Fragment>{activeScreen === 3 && <Screen4 />}</Fragment>

        {/* Screen 5 */}
        <Fragment>{activeScreen === 4 && <Screen5 />}</Fragment>

        {/* Screen 6 */}
        <Fragment>{activeScreen === 5 && <Screen6 />}</Fragment>

        {/* Screen 7 */}
        <Fragment>{activeScreen === 6 && <Screen7 />}</Fragment>

        {/* Screen 8 */}
        <Fragment>{activeScreen === 7 && <Screen8 />}</Fragment>

        {/* Screen 9 */}
        <Fragment>{activeScreen === 8 && <Screen9 />}</Fragment>

        {/* Screen 10 */}
        <Fragment>{activeScreen === 9 && <Screen10 />}</Fragment>

        {/* Screen 11 */}
        <Fragment>{activeScreen === 10 && <Screen11 />}</Fragment>

        {/* Screen 12 */}
        <Fragment>{activeScreen === 11 && <Screen12 />}</Fragment>

        {/* Screen 13 */}
        <Fragment>{activeScreen === 12 && <Screen13 />}</Fragment>
      </Fragment>
    );
  };

  useEffect(() => {
    /* For Progressbar */
    const stepProgress = ((activeScreen + 1) * 100) / steps.length;
    setProgress(stepProgress);
    setBuffer(stepProgress + Math.random() * 10 + Math.random() * 10);

    /* For Side Info */
    switch (activeScreen) {
      case 0:
        setActiveFocus("year");
        break;

      case 1:
        setActiveFocus("year");
        break;

      case 2:
        setActiveFocus("title");
        break;

      case 3:
        setActiveFocus("vin");
        break;

      case 4:
        setActiveFocus("wheels");
        break;

      case 5:
        setActiveFocus("key");
        break;

      case 6:
        setActiveFocus("engineTransmission");
        break;

      case 7:
        setActiveFocus("catalyticConverter");
        break;

      default:
        setActiveFocus("year");
        break;
    }

    // eslint-disable-next-line
  }, [activeScreen]);

  /* Snackbar Action Component */
  const snackbarAction = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowSnackbar(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <Fragment>
      {showSpinner && (
        <div className="spinner">
          <Spinner />
        </div>
      )}

      <Snackbar
        open={showSnackbar}
        autoHideDuration={5000}
        onClose={() => setShowSnackbar(false)}
        message={snackbarMessage}
        action={snackbarAction}
      />

      <div className="container">
        <div className="section screenContainer">
          <div className="screenWrapper">
            <Box sx={{ width: '100%' }}>
              <Typography variant="h5" component="h2" align="center">
                {steps[activeScreen]}
              </Typography>

              <LinearProgress
                variant="buffer"
                value={progress}
                valueBuffer={buffer}
                sx={{ mt: 4 }}
              />

              {activeScreen === steps.length - 1 ? (
                <Fragment>
                  <Typography sx={{ mt: 2, mb: 1 }}>
                    Your pickup has been scheduled! We have sent a confirmation
                    to {screensData.screen11.email}. We'll call you before we
                    send a tow truck to the pickup location.
                  </Typography>
                  <Box className="screenBtnContainer" sx={{ pt: 5 }}>
                    <a href="http://aicarbuyer.com" style={{ textDecoration: "none" }}>
                    <Button
                      variant="contained"
                      color="primary"
                    >
                      Go To Home
                    </Button>
                    </a>
                  </Box>
                </Fragment>
              ) : (
                <Fragment>
                  <div className="section padding-bottom-none"></div>
                  {renderScreen()}
                </Fragment>
              )}
            </Box>
          </div>

          {activeScreen < 8 && activeFocus && (
            <div className="screenInfo">
              <Box sx={{ width: "100%" }}>
                <picture className="screenInfo__picture">
                  <img src={stepsInfoData[activeFocus]?.image} alt="Year" />
                </picture>
                <Typography
                  variant="h6"
                  component="h2"
                  align="center"
                  sx={{ py: 1 }}
                >
                  {stepsInfoData[activeFocus]?.name}
                </Typography>

                <Typography variant="caption" component="p" align="left">
                  {stepsInfoData[activeFocus]?.text}
                </Typography>
              </Box>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Home;
